export const ANI_TIME = 0.3;
export const PAGE_SIZE = 25;
export const TAB_KEY_MAP = {
  recommend: 9998,
  collect: 9999,
  all: 9997,
};
